import { render, staticRenderFns } from "./JiraModal.vue?vue&type=template&id=2da519d0&"
import script from "./JiraModal.vue?vue&type=script&lang=js&"
export * from "./JiraModal.vue?vue&type=script&lang=js&"
import style0 from "./JiraModal.vue?vue&type=style&index=0&id=2da519d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports